import React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';

import { styles } from './TextOverflow.styles';

interface Props extends WithStyles<typeof styles> {
  text: string;
}

const TextOverflow: React.FC<Props> = (props) => {
  const { classes, text } = props;
  const textElementRef = React.useRef<HTMLDivElement>(null);
  const [isOverflowed, setIsOverflow] = React.useState(false);

  React.useEffect(() => {
    if (textElementRef?.current?.scrollWidth && textElementRef.current.clientWidth) {
      setIsOverflow(textElementRef?.current?.scrollWidth > textElementRef.current.clientWidth);
    }
  }, []);

  return (
    <div className={classes.text} ref={textElementRef}>
      {text}
      {isOverflowed && <span className={classes.tooltip}>{text}</span>}
    </div>
  );
};

export default withStyles(styles)(TextOverflow);
